import FooterAuth from '../layout/footer/FooterAuth';

export default function Auth({ children }) {
    return (
        <>
            <div className='rtl'>
                {children}

                <div className='space-50' />

                <FooterAuth />
            </div>
        </>
    );
}
